import * as React from 'react'
import { INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import { PresentationsViewOnly } from './PresentationsViewOnly'
import { PresentationsStudentFacing } from './PresentationsStudentFacing'

const fixOptions = [
  { label: 'View Only Fix', value: 'viewOnly' },
  { label: 'Student Facing Fix', value: 'studentFacing' },
]

export function PresentationsTreeFix({ tree }: { tree: INode }) {
  const [currentView, setCurrentView] = React.useState('')

  return (
    <Box>
      <Box>
        {fixOptions.map(({ value, label }) => (
          <Button
            key={value}
            disabled={currentView === value}
            onClick={() => setCurrentView(value)}
          >
            {label}
          </Button>
        ))}
      </Box>
      {currentView === 'viewOnly' && <PresentationsViewOnly tree={tree} />}
      {currentView === 'studentFacing' && (
        <PresentationsStudentFacing tree={tree} />
      )}
    </Box>
  )
}
